import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { IndustryIcons } from './IndustryIcons';
export const WhoThisIsFor = () => {
  const forYou = ['You run a 7–8 figure coaching, agency, insurance, mortgage, real estate, solar, or auto sales org.', 'You have 5–30 full‑time reps taking sales calls or running demos.', 'Your sales cycle is ≤ 30 days from first call to close (up to 60 days for fast‑cycle real estate).', 'You have consistent lead flow – your issue is conversion and consistency.', 'Your core offer is dialed in – clear product, pricing, and avatar.', 'You have at least one sales leader and a CRM in place (HubSpot, HighLevel, Salesforce, etc.).'];
  const notForYou = ['You re still doing founder led sales and personally take most calls.', 'You have fewer than 5 reps, or are "thinking about hiring" your first closer.', "You don't have consistent lead flow yet.", 'Your sales cycle is months or years (long‑cycle enterprise, jets, government).', 'You re expecting us to recruit reps, build an outsourced agency, or run your sales team.'];
  return <div className="w-full py-10 sm:py-16 md:py-24" data-id="element-338">
      <div className="max-w-5xl mx-auto px-4" data-id="element-339">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-8 sm:mb-12 text-[#F5F5F7] text-center leading-tight" data-id="element-340">
          Who This Is For (and Not For)
        </h2>

        <IndustryIcons data-id="element-341" />

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12" data-id="element-342">
          {/* This is for you */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gradient-to-br from-[#0A1BFF]/10 to-[#1457FF]/10 backdrop-blur-sm border border-[#1457FF]/30 rounded-xl p-5 sm:p-6 md:p-8" data-id="element-343">
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#F5F5F7] mb-4 sm:mb-6 flex items-center gap-2" data-id="element-344">
              <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-[#1457FF]" data-id="element-345" />
              This is for you if:
            </h3>
            <ul className="space-y-3 sm:space-y-4" data-id="element-346">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-2 sm:gap-3" data-id="element-347">
                  <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-[#1457FF] flex-shrink-0 mt-0.5" data-id="element-348" />
                  <span className="text-[#F5F5F7]/80 text-xs sm:text-sm md:text-base" data-id="element-349">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* This is NOT for you */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gradient-to-br from-[#6366F1]/10 to-[#7C3AED]/10 backdrop-blur-sm border border-[#7C3AED]/30 rounded-xl p-5 sm:p-6 md:p-8" data-id="element-350">
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#F5F5F7] mb-4 sm:mb-6 flex items-center gap-2" data-id="element-351">
              <XCircle className="w-5 h-5 sm:w-6 sm:h-6 text-[#7C3AED]" data-id="element-352" />
              This is NOT for you if:
            </h3>
            <ul className="space-y-3 sm:space-y-4" data-id="element-353">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-2 sm:gap-3" data-id="element-354">
                  <XCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#7C3AED] flex-shrink-0 mt-0.5" data-id="element-355" />
                  <span className="text-[#F5F5F7]/80 text-xs sm:text-sm md:text-base" data-id="element-356">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <CTAButton className="mt-6 sm:mt-8" data-id="element-357" />
      </div>
    </div>;
};